module.exports = "/assets/site/images/uszas.jpg?22d009190e2f225a0adc973e34e659e6";